(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-cards-carousel"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.custom-card__cover-wrapper').forEach((wrapper) => {
    wrapper.addEventListener('click', function () {
      const container = this.closest('.custom-card__media');
      const coverWrapper = container.querySelector('.custom-card__cover-wrapper');
      const videoWrapper = container.querySelector('.custom-card__video-wrapper');
      const iframe = videoWrapper.querySelector('iframe');

      if (iframe && iframe.src.indexOf('autoplay=1') === -1) {
        iframe.src += (iframe.src.indexOf('?') > -1 ? '&' : '?') + 'autoplay=1';
        coverWrapper.style.display = 'none';
        videoWrapper.style.zIndex = 2;
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
